import { IState, DefaultState } from "./state";
import { Types, Keys } from "./action/types";
import { ActivitySchedule, ActivityReservation } from '../../../model/activities';

export const reducer = (
    state: IState = DefaultState(),
    action: Types
): IState => {
    switch (action.type) {
        case Keys.GETSCHEDULES:
        case Keys.GETSCHEDULES_PENDING:
            {
                return {
                    ...state,
                    isLoading: true
                }
            }
        case Keys.GETSCHEDULES_FULFILLED:
            {
                const s = action.payload;
                if (s)
                    s.forEach((element: ActivitySchedule) => {
                        element.date = new Date(element.date);
                    });
                return {
                    ...state,
                    schedules: s,
                    isLoading: false
                }
            }
        case Keys.GETSCHEDULES_REJECTED:
            {
                return {
                    ...state,
                    isLoading: false
                }
            }
        case Keys.DELETESCHEDULE:
        case Keys.DELETESCHEDULE_PENDING:
        case Keys.CREATESCHEDULE:
        case Keys.CREATESCHEDULE_PENDING:
        case Keys.SAVESCHEDULE_PENDING:
        case Keys.SAVESCHEDULE: {
            return {
                ...state,
                isLoadingDetails: true,
                isLoading: true,
            }
        }
        case Keys.DELETESCHEDULE_REJECTED:
        case Keys.CREATESCHEDULE_REJECTED:
        case Keys.SAVESCHEDULE_REJECTED: {
            return {
                ...state,
                isLoadingDetails: false,
                isLoading: false,
            }
        }
        case Keys.SAVESCHEDULE_FULFILLED: {
            const curr = [...state.schedules];
            action.payload.date = new Date(action.payload.date);
            let idx = curr.findIndex(a => a._id === action.payload._id);
            if (idx > -1)
                curr.splice(idx, 1, action.payload);
            return {
                ...state,
                schedules: curr,
                isLoading: false,
                isLoadingDetails: false
            }
        }
        case Keys.CREATESCHEDULE_FULFILLED: {
            action.payload.date = new Date(action.payload.date);
            const curr = [...state.schedules, action.payload];
            return {
                ...state,
                schedules: curr,
                isLoading: false,
                isLoadingDetails: false,
            }
        }
        case Keys.DELETESCHEDULE_FULFILLED: {
            const curr = [...state.schedules];
            let idx = curr.findIndex(a => a._id === action.meta);
            if (idx > -1)
                curr.splice(idx, 1);
            return {
                ...state,
                schedules: curr,
                isLoading: false,
                isLoadingDetails: false
            }
        }
        case (Keys.LOADACTIVITIES_FULFILLED): {
            const activities = (action.payload || []).map(a => {
                return {
                    ...a,
                    validFrom: new Date(a.validFrom),
                    expiresOn: new Date(a.expiresOn)
                }
            })
            return {
                ...state,
                allActivities: activities,
                isLoading: false,
            }
        }
        case (Keys.LOADACTIVITIES_REJECTED): {
            return {
                ...state,
                isLoading: false
            }
        }
        case (Keys.LOADACTIVITIES): {
            return {
                ...state,
                isLoading: true
            }
        }
        case (Keys.LOADACTIVITIES_PENDING): {
            return {
                ...state,
                isLoading: true
            }
        }

        case Keys.GETRESERVATIONS:
        case Keys.GETRESERVATIONS_PENDING:
            {
                return {
                    ...state,
                    isLoadingReservations: true
                }
            }
        case Keys.GETRESERVATIONS_FULFILLED:
            {
                const s = action.payload;
                if (s)
                    s.forEach((element: ActivitySchedule) => {
                        element.date = new Date(element.date);
                    });
                return {
                    ...state,
                    reservations: s,
                    isLoadingReservations: false
                }
            }
        case Keys.GETRESERVATIONS_REJECTED:
            {
                return {
                    ...state,
                    isLoadingReservations: false
                }
            }
        case Keys.REMOVERESERVATION:
        case Keys.REMOVERESERVATION_PENDING:
        case Keys.ADDRESERVATION:
        case Keys.ADDRESERVATION_PENDING:
            {
                return {
                    ...state,
                    isLoadingReservations: true
                }
            }
        case Keys.ADDRESERVATION_FULFILLED:
            {
                const r = action.payload as ActivityReservation;
                let s = state.schedules.findIndex(a => a._id === r.activityScheduleId);
                if (s > -1)
                {
                    const resIdx =state.schedules[s].reservations.findIndex(a=>a._id === r._id); 
                    if(resIdx === -1)
                        state.schedules[s].reservations = [...state.schedules[s].reservations,r];
                }
                let res = state.reservations.findIndex(a => a._id = r._id)
                if (res > -1)
                    state.reservations = [...state.reservations, r];
                return {
                    ...state,
                    schedules: [...state.schedules],
                    reservations: [...state.reservations],
                    isLoadingReservations: false
                }
            }
        case Keys.REMOVERESERVATION_FULFILLED:
            {
                const r = action.payload;
                // console.log("------------------------------------------r-e-m-o-v-e-------------2-")
                // console.log(r)
                let s = state.schedules.findIndex(a => a._id === r.activityScheduleId); 
                // console.log("------------------------------------------r-e-m-o-v-e-------------3-")
                // console.log(state.schedules[s].reservations)
                // console.log("------------------------------------------r-e-m-o-v-e-------------4-")
                // console.log(state.reservations)
                if (s > -1) {
                    let i2 = state.schedules[s].reservations.findIndex(a => a._id === r._id);
                    // console.log("i2:"+ i2)
                    state.schedules[s].reservations.splice(i2, 1);
                }
                // let res = state.reservations.findIndex(a => a._id = r._id)
                // if (res > -1)
                //     state.reservations.splice(s, 1);
                return {
                    ...state,
                    schedules: [...state.schedules],
                    reservations: [...state.reservations],
                    isLoadingReservations: false
                }
            }
        case Keys.ADDRESERVATION_REJECTED:
        case Keys.REMOVERESERVATION_REJECTED:
            {
                return {
                    ...state,
                    isLoadingReservations: false
                }
            }
        default:
            return state;
    }
};
